import { useCallback } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { updateClientsOpt } from 'services/options-service';
import { notify, getApiFormError, cloneDeep } from 'libs/common';
import { Button, themes, Alert } from 'libs/ui';
import { required, WhiteStyledField, ErrorMsg, Toggle, ButtonsContainer /*, minValue, maxValue*/ } from 'libs/form';
import { Content } from './clients-opt-full-form.styled';
// import { StyledButtonContainer, RidesWrapperToggle } from './epm-form.styled';

const ClientsOptFullFormForm = (props) => {
  const { error, handleSubmit } = props;

  const { t } = useTranslation();
  const requiredT = useCallback(required(t), [t]);
  // const minValue1 = useCallback(minValue(t, 1), [t]);
  // const maxValue31 = useCallback(maxValue(t, 31), [t]);

  /**
   * after submit
   */
  const afterSubmit = () => {
    notify(t('messages.ВНИМАНИЕ!'), t('messages.Изменения сохранены'), 'success');
  };

  /**
   * submit
   * @param {*} values
   * @returns
   */
  const submit = (data) => {
    // data
    const out = cloneDeep(data);
    // console.log("out", out);
    // return;
    out.update_day = 1; //Number(out.update_day);
    // out.id = initialValues.id;
    Object.keys(out.update_amount).forEach((fn) => {
      out.update_amount[fn] *= 100;
    });

    // do
    return updateClientsOpt(out)
      .then(() => {
        afterSubmit();
      })
      .catch((error) => {
        const errors = getApiFormError(error);
        throw new SubmissionError(errors);
      });
  };

  return (
    <Content>
      <form onSubmit={handleSubmit(submit)}>
        <ErrorMsg error={error} />

        <Toggle className="green-red1 lk1" type="toggle" label={t('form.Автоматическое пополнение баланса')} name="is_active" />

        <p style={{ width: '100%' }}>{t('grid.Сумма')}</p>
        <WhiteStyledField type="text" label={t('form.Юр. лицо')} placeholder={'0'} name="update_amount.legal_person" validate={requiredT} mask={{ suffix: t('form.руб') }} />
        <WhiteStyledField type="text" label={t('form.Физ. лицо')} placeholder={'0'} name="update_amount.natural_person" validate={requiredT} mask={{ suffix: t('form.руб') }} />
        <WhiteStyledField type="text" label={t('form.ИП')} placeholder={'0'} name="update_amount.sole_proprietor" validate={requiredT} mask={{ suffix: t('form.руб') }} />

        {/* <WhiteStyledField
          type="text"
          label={t('grid.День месяца')}
          placeholder={'1-31'}
          name="update_day"
          // mask={{ suffix: '' }}
          min={1}
          max={31}
          naturalNumber
          validate={[minValue1, maxValue31]}
        /> */}

        <div style={{ padding: '16px 3px 16px 0' }}>
          <Alert>{t('messages.Автообновление балансов будет происходить первого числа каждого месяца в 0000')}</Alert>
        </div>

        <ButtonsContainer space="20px" style={{ marginTop: '10px' }}>
          <Button theme={themes.blue}>
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </ButtonsContainer>
      </form>
    </Content>
  );
};

export const ClientsOptFullForm = reduxForm({
  form: 'clientsOptFullForm',
  destroyOnUnmount: false,
})(ClientsOptFullFormForm);
